<template>
  <!-- UI -->
  <nav class="custom-nav blue-grey darken-4 hide-on-med-and-down"></nav>

  <nav class="nav-extended sub-nav-shell blue-grey darken-3 hide-on-med-and-down">
    <div class="nav-wrapper container">
      <a href="#!" class="brand-logo sub-nav-brand" @click.prevent="handleActive(home)">
        <i class="material-icons">apps</i>
        <span>{{ home?.name }}</span>
      </a>
      <ul class="right hide-on-med-and-down sub-nav-links">
        <li v-for="tab in tabs" :key="tab.id" :class="{ 'is-active': tab.id == currTab?.id }">
          <a href="#" @click.prevent="handleActive(tab)">
            <span>{{ tabLabel(tab) }}</span>
            <span class="sub-nav-badge" v-if="tabBadge(tab)">{{ tabBadgeLabel(tab) }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="nav-content">
      <!-- empty -->
    </div>
  </nav>
  <nav class="sub-nav-mobile blue-grey darken-4 hide-on-large-only">
    <ul class="tabs tabs-transparent sub-nav-mobile-tabs">
      <li v-for="tab in tabs" :key="tab.id" class="tab" :class="{ 'is-active': tab.id == currTab?.id }">
        <a href="#" @click.prevent="handleActive(tab)">
          <span>{{ tab?.title?.split(" ")[0] }}</span>
          <span class="sub-nav-badge" v-if="tabBadge(tab)">{{ tabBadgeLabel(tab) }}</span>
        </a>
          <!-- <a href="#" @click.prevent="handleActive(tab)" v-else>{{ tab.title }}</a> -->
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "HeaderSubComponent",
  emits: ["active"],
  props: ["home", "tabs", "shorts", "currTab", "color"],
  setup(props, context) {
    const handleActive = (val) => {
      context.emit("active", val);
    }

    const tabLabel = (tab) => {
      return props.shorts ? tab?.title?.split(" ")[0] : tab?.title;
    };

    const tabBadge = (tab) => {
      return Number(tab?.badge || 0);
    };

    const tabBadgeLabel = (tab) => {
      const count = tabBadge(tab);
      return count > 99 ? "99+" : count;
    };

    return {
      handleActive,
      tabLabel,
      tabBadge,
      tabBadgeLabel,
    };
  },
};
</script>

<style scoped>
.custom-nav {
  height: 4px;
  line-height: 4px;
}

.sub-nav-shell {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 14px 24px -14px rgba(20, 31, 38, 0.95);
}

.sub-nav-shell .nav-wrapper {
  align-items: center;
  display: flex;
  height: 52px;
  justify-content: space-between;
}

.sub-nav-brand {
  align-items: center;
  display: inline-flex;
  gap: 10px;
  font-size: 1.24rem;
  font-weight: 700;
  height: 36px;
  letter-spacing: 0;
  line-height: 36px;
  position: static;
  transform: none;
}

.sub-nav-brand i {
  align-items: center;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 6px;
  display: inline-flex;
  font-size: 18px;
  height: 30px;
  justify-content: center;
  line-height: 30px;
  margin: 0;
  width: 30px;
}

.sub-nav-links {
  align-items: center;
  display: flex;
  gap: 6px;
  height: 36px;
}

.sub-nav-links li {
  border: 1px solid transparent;
  border-radius: 6px;
  height: 32px;
  line-height: 32px;
  transition: background-color 0.18s ease, border-color 0.18s ease;
}

.sub-nav-links li:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.1);
}

.sub-nav-links li.is-active {
  background: transparent;
  border-color: transparent;
}

.sub-nav-links li a {
  align-items: center;
  color: #ffffff;
  display: inline-flex;
  gap: 7px;
  font-weight: 600;
  height: 32px;
  letter-spacing: 0;
  line-height: 32px;
  padding: 0 14px;
}

.sub-nav-links li.is-active a {
  color: #ffffff;
  text-decoration: underline;
  text-decoration-color: #ffffff;
  text-decoration-thickness: 2px;
  text-underline-offset: 6px;
}

.sub-nav-badge {
  align-items: center;
  background: #f9a825;
  border: 1px solid rgba(255, 255, 255, 0.42);
  border-radius: 999px;
  box-shadow: 0 6px 12px -8px rgba(0, 0, 0, 0.65);
  color: #263238;
  display: inline-flex;
  font-size: 0.68rem;
  font-weight: 900;
  height: 19px;
  justify-content: center;
  line-height: 19px;
  min-width: 19px;
  padding: 0 5px;
}

.nav-content {
  min-height: 4px;
}

.sub-nav-mobile {
  box-shadow: none;
  min-height: 56px;
  overflow-x: auto;
  scrollbar-width: none;
  width: 100%;
}

.sub-nav-mobile::-webkit-scrollbar {
  display: none;
}

.sub-nav-mobile-tabs {
  align-items: center;
  display: flex;
  min-height: 56px;
  padding: 6px 8px 0;
  gap: 0;
  width: max-content;
  min-width: 100%;
}

.sub-nav-mobile-tabs .tab {
  background: transparent;
  border: 0;
  border-radius: 0;
  flex: 1 0 auto;
  height: 50px;
  line-height: 50px;
  text-transform: none;
  transition: background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}

.sub-nav-mobile-tabs .tab a {
  align-items: center;
  color: rgba(255, 255, 255, 0.72);
  display: inline-flex;
  gap: 6px;
  font-weight: 600;
  height: 50px;
  justify-content: center;
  letter-spacing: 0;
  line-height: 50px;
  min-width: 76px;
  padding: 0 14px;
  text-transform: none;
  width: 100%;
}

.sub-nav-mobile-tabs .sub-nav-badge {
  font-size: 0.62rem;
  height: 17px;
  line-height: 17px;
  min-width: 17px;
  padding: 0 4px;
}

.sub-nav-mobile-tabs .tab:hover {
  background: rgba(255, 255, 255, 0.045);
}

.sub-nav-mobile-tabs .tab.is-active {
  background: transparent;
}

.sub-nav-mobile-tabs .tab.is-active a {
  color: #ffffff;
  font-weight: 800;
  text-decoration: underline;
  text-decoration-color: #ffffff;
  text-decoration-thickness: 2px;
  text-underline-offset: 7px;
}

.sub-nav-mobile-tabs :deep(.indicator) {
  display: none;
}

@media only screen and (min-width: 601px) and (max-width: 992px) {
  .sub-nav-mobile {
    min-height: 58px;
  }

  .sub-nav-mobile-tabs {
    min-height: 58px;
    padding: 6px 4vw 0;
  }

  .sub-nav-mobile-tabs .tab {
    height: 52px;
    line-height: 52px;
  }

  .sub-nav-mobile-tabs .tab a {
    font-size: 0.88rem;
    height: 52px;
    line-height: 52px;
    min-width: 96px;
    padding: 0 16px;
  }
}

@media only screen and (max-width: 600px) {
  .sub-nav-mobile {
    min-height: 48px;
  }

  .sub-nav-mobile-tabs {
    min-height: 48px;
    padding: 4px 10px 0;
  }

  .sub-nav-mobile-tabs .tab,
  .sub-nav-mobile-tabs .tab a {
    height: 44px;
    line-height: 44px;
  }

  .sub-nav-mobile-tabs .tab a {
    font-size: 0.82rem;
    min-width: 78px;
    padding: 0 12px;
  }
}
</style>
